// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HorizontalStackedTokens_wrapper__2Gws0","nounWrapper":"HorizontalStackedTokens_nounWrapper__1ppot"};